import React, { useState } from "react";
import AppIcon from "../../components/AppIcon";
import SettingApp from "./setting.jsx";
import { SettingOutlined } from "@ant-design/icons";
import { themeColors } from "../../config.js";

const Setting = ({
  fileSystem,
  userInfo,
  localMode,
  systemData,
  updateSystemData,
  backgrounds,
  scale,
}) => {
  const [isOpen, setOpen] = useState(false);
  return (
    <div>
      {isOpen && (
        <SettingApp
          fileSystem={fileSystem}
          userInfo={userInfo}
          localMode={localMode}
          systemData={systemData}
          updateSystemData={updateSystemData}
          backgrounds={backgrounds}
          onCancel={() => setOpen(!isOpen)}
        />
      )}
      <AppIcon
        key={"setting"}
        icon={
          <SettingOutlined
            style={{ fontSize: 30, color: themeColors.yellow }}
          />
        }
        name={"Setting"}
        width={100}
        height={110}
        onClick={() => setOpen(!isOpen)}
        nameOnChange={false}
        nameChangable={false}
        scale={scale}
      />
    </div>
  );
};

export default Setting;
